import { createContext } from 'react';

/**
 * Thin auth context — only application-level actions and error state.
 *
 * Use msal-react hooks directly for authentication state:
 *   - useIsAuthenticated()      → boolean
 *   - useMsal().inProgress      → InteractionStatus (loading indicator)
 *   - useAccount()              → AccountInfo | null
 *   - useMsal().accounts        → AccountInfo[]
 */
export interface AuthContextType {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: (forceRefresh?: boolean) => Promise<string | null>;
  error: string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
